import * as _ from '@antv/util';
var EVENT_TYPES = [
    'start',
    'process',
    'end',
    'reset',
];
var Interaction = /** @class */ (function () {
    function Interaction(cfg) {
        var defaultCfg = this._getDefaultCfg();
        _.assign(this, defaultCfg, cfg);
        this.canvas = this.view.get('canvas');
        this._eventHandlers = [];
        this._bindEvents();
    }
    Interaction.prototype._getDefaultCfg = function () {
        return {
            startEvent: 'mousedown',
            processEvent: 'mousemove',
            endEvent: 'mouseup',
            resetEvent: 'dblclick',
        };
    };
    Interaction.prototype._start = function (ev) {
        this.preStart(ev);
        this.start(ev);
        this.afterStart(ev);
    };
    Interaction.prototype.preStart = function (ev) {
    };
    Interaction.prototype.start = function (ev) {
    };
    Interaction.prototype.afterStart = function (ev) {
    };
    Interaction.prototype._process = function (ev) {
        this.preProcess(ev);
        this.process(ev);
        this.afterProcess(ev);
    };
    Interaction.prototype.preProcess = function (ev) {
    };
    Interaction.prototype.process = function (ev) {
    };
    Interaction.prototype.afterProcess = function (ev) {
    };
    Interaction.prototype._end = function (ev) {
        this.preEnd(ev);
        this.end(ev);
        this.afterEnd(ev);
    };
    Interaction.prototype.preEnd = function (ev) {
    };
    Interaction.prototype.end = function (ev) {
    };
    Interaction.prototype.afterEnd = function (ev) {
    };
    Interaction.prototype._reset = function (ev) {
        this.preReset(ev);
        this.reset(ev);
        this.afterReset(ev);
    };
    Interaction.prototype.preReset = function (ev) {
    };
    Interaction.prototype.reset = function (ev) {
    };
    Interaction.prototype.afterReset = function (ev) {
    };
    Interaction.prototype._bindEvents = function () {
        var _this = this;
        _.each(EVENT_TYPES, function (type) {
            var eventName = _this[type + "Event"];
            var handler = _.wrapBehavior(_this, "_" + type);
            _this.view.on(eventName, handler);
            _this._eventHandlers.push({ type: eventName, handler: handler });
        });
    };
    Interaction.prototype._unbindEvents = function () {
        var _this = this;
        var eventHandlers = this._eventHandlers;
        _.each(eventHandlers, function (eh) {
            _this.view.off(eh.type, eh.handler);
        });
    };
    Interaction.prototype.destroy = function () {
        this._unbindEvents();
        this._reset();
    };
    return Interaction;
}());
export default Interaction;
//# sourceMappingURL=base.js.map